import { classNames } from 'primereact/utils';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useChangeStatusMutation, useGetAuftraegeMutation } from '../../api/AuftragAPI';
import { LoadingModal } from '../../component/LoadingModal/LoadingModal';
import { setListAuftragWithStatus } from '../../Slice/AllParameter';
import { AppDispatch, RootState } from '../../Store';
import { IAuftrag, IGetAuftraegeRequestDto } from '../../types/Types';
import Footer from '../footer/Footer';
import LandingpageHeader from '../header/LandingpageHeader';
import styles from './auftrag.module.scss';
import AuftragAnzeigeTerminiert from './AuftragAnzeigeTerminiert';
import AuftragAnzeigeWiedervorlage from './AuftragAnzeigeWiedervorlage';
import AuftragTerminieren from './AuftragTerminieren';
import AuftragAnzeigeStorno from './AuftragAnzeigeStorno';

/**
 * @author noone
 */
export default function AuftragMain() {

    const navigate = useNavigate();
    const { t } = useTranslation();
    const dispatch = useDispatch<AppDispatch>();

    const [isLoading, setIsLoading] = useState<boolean>(false);

    const [getAuftraegAPI] = useGetAuftraegeMutation();
    const [changeStatusAPI] = useChangeStatusMutation();

    const listauftragwithstatus = useSelector((state: RootState) => state.allParameter.listAuftragWithStatus);

    const [auftragsliste, setAuftragsliste] = useState<IAuftrag[]>([]);
    const [gruppierung, setGruppierung] = useState<Map<string, number>>(new Map());

    const handleNextStatus = (uid: string, nextstatus: string) => {
        changeStatusAPI({ uid: uid, neuerStatus: nextstatus })
            .then(() => {
                ladeListe();
                aktualisiereStatusAnzahlAnzeige();
            })
            .catch((error) => console.log(error))
            ;
    }

    const aktualisiereStatusAnzahlAnzeige = () => {

        var para: IGetAuftraegeRequestDto = {
            status: ["NEU", "IN_TERMINIERUNG", "WIEDERVORLAGE", "TERMINIERT", "FAKTURIERBAR", "STORNO"]
        }
        getAuftraegAPI(para).unwrap()
            .then(data => {
                const newMap = new Map<string, number>();
                data.map((auftrag) => {
                    var suchstatus = (auftrag.status === "NEU") ? "IN_TERMINIERUNG" : auftrag.status;
                    var anzahl = newMap.get(suchstatus);
                    if (anzahl === undefined)
                        anzahl = 1;
                    else
                        anzahl = anzahl + 1;
                    newMap.set(suchstatus, anzahl);
                });
                setGruppierung(newMap);
            })
            .catch((e) => alert("" + e))
            .finally(() => setIsLoading(false))
            ;
    }

    const ladeListe = async () => {
        setIsLoading(true);
        var para: IGetAuftraegeRequestDto = {
            status: (listauftragwithstatus === "IN_TERMINIERUNG") ? ["NEU", "IN_TERMINIERUNG"] : [listauftragwithstatus]
        }
        await getAuftraegAPI(para).unwrap()
            .then(data => setAuftragsliste(data))
            .catch((e) => alert("" + e))
            .finally(() => setIsLoading(false))
            ;
    }

    const statusChanged = () => {
        ladeListe();
        aktualisiereStatusAnzahlAnzeige();
    }

    useEffect(() => {
        ladeListe();
    }, [listauftragwithstatus]);

    useEffect(() => {
        ladeListe();
        aktualisiereStatusAnzahlAnzeige();
    }, []);

    return (
        <div>

            <LoadingModal show={isLoading} />

            <LandingpageHeader />

            <div style={{ padding: "20px" }}>

                <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <button
                        onClick={() => {
                            navigate({
                                pathname: "/",
                                search: ""
                            });
                        }}

                        style={{ marginBottom: "20px" }}
                        className=' btn btn-outline-primary'
                    >
                        <i className="bi bi-arrow-left"></i> {t('deTranslation.auftragDetails.backButton')}
                    </button>

                    <button
                        onClick={() => {
                            navigate({
                                pathname: "./search",
                                search: ""
                            });
                        }}

                        style={{ marginBottom: "20px" }}
                        className=' btn btn-outline-primary'
                    >
                        Suche Auftrag <i className="bi bi-search"></i>
                    </button>
                </div>

                <h4 style={{ textAlign: "center" }}>Aufträge</h4>

                <div className={styles["auftragStatusBtnRow"]}>

                    <div className={(listauftragwithstatus === "IN_TERMINIERUNG") ? "btn btn-primary" : "btn btn-light"} onClick={() => dispatch(setListAuftragWithStatus("IN_TERMINIERUNG"))}>

                        <span className={styles["auftragStatusBtnRow_Content"]}>in Terminierung ( {gruppierung.get("IN_TERMINIERUNG") ? gruppierung.get("IN_TERMINIERUNG") : "-"} )</span>

                    </div>

                    <div className={(listauftragwithstatus === "WIEDERVORLAGE") ? "btn btn-primary" : "btn btn-light"} onClick={() => dispatch(setListAuftragWithStatus("WIEDERVORLAGE"))}>

                        <span className={styles["auftragStatusBtnRow_Content"]}>Wiedervorlage ( {gruppierung.get("WIEDERVORLAGE") ? gruppierung.get("WIEDERVORLAGE") : "-"} )</span>

                    </div>

                    <div className={(listauftragwithstatus === "TERMINIERT") ? "btn btn-primary" : "btn btn-light"} onClick={() => dispatch(setListAuftragWithStatus("TERMINIERT"))}>

                        <span className={styles["auftragStatusBtnRow_Content"]}>Terminiert ( {gruppierung.get("TERMINIERT") ? gruppierung.get("TERMINIERT") : "-"} )</span>

                    </div>

                    <div className={(listauftragwithstatus === "FAKTURIERBAR") ? "btn btn-primary" : "btn btn-light"} onClick={() => dispatch(setListAuftragWithStatus("FAKTURIERBAR"))}>

                        <span className={styles["auftragStatusBtnRow_Content"]}>Fakturierbar ( {gruppierung.get("FAKTURIERBAR") ? gruppierung.get("FAKTURIERBAR") : "-"} )</span>

                    </div>

                    <div className={(listauftragwithstatus === "STORNO") ? "btn btn-primary" : "btn btn-light"} onClick={() => dispatch(setListAuftragWithStatus("STORNO"))}>

                        <span className={styles["auftragStatusBtnRow_Content"]}>STORNO ( {gruppierung.get("STORNO") ? gruppierung.get("STORNO") : "-"} )</span>

                    </div>

                </div>


                {listauftragwithstatus === "FAKTURIERBAR" &&
                    <>
                        <div className={classNames(styles.auftragList)}>

                            {auftragsliste?.length === 0 && <div>Keine Aufträge vorhanden</div>}

                            <table className="table" style={{ width: "100%", marginTop: "20px" }}>
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th scope="col">Name</th>
                                        <th scope="col">Stadt</th>
                                        <th scope="col">Zugeteilt</th>
                                        <th scope="col">Auftragsnr. Kunde</th>
                                        <th scope="col">Option</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {auftragsliste?.map((auftrag, index) => (
                                        <tr key={index}>
                                            <td>{auftrag.art}</td>
                                            <td>{auftrag.name_endkunde}</td>
                                            <td>{auftrag.stadt_lieferadresse}</td>
                                            <td>{auftrag.ausfuehrungvon?.name}</td>
                                            <td>{auftrag.auftragsnr_ag}</td>
                                            <td>
                                                <button title='Storno' className="btn btn-warning" onClick={() => handleNextStatus(auftrag.uid, "TERMINIERT")}><i className="bi bi-arrow-left"></i> Wieder auf TERMINIERT</button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </>
                }

                {listauftragwithstatus === "IN_TERMINIERUNG" &&
                    <><AuftragTerminieren liste={auftragsliste} statusChanged={statusChanged} /></>
                }

                {listauftragwithstatus === "WIEDERVORLAGE" &&
                    <><AuftragAnzeigeWiedervorlage liste={auftragsliste} statusChanged={statusChanged} /></>
                }

                {listauftragwithstatus === "TERMINIERT" &&
                    <><AuftragAnzeigeTerminiert liste={auftragsliste} statusChanged={statusChanged} /></>
                }

                {listauftragwithstatus === "STORNO" &&
                    <><AuftragAnzeigeStorno liste={auftragsliste} statusChanged={statusChanged} /></>
                }

            </div>
            <Footer />
        </div >
    );

}

